<template>
  <header class="container">
    <h1>Garage Rats Car Club</h1>
    <h2>Erie, Colorado</h2>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader'
}
</script>

<style scoped>
  header {
    background-color: #66c0f4;
    font-family: 'Courgette', cursive;
    color: #fff;
    text-align: center;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  header h1 {
    font-size: 3.5em;
  }
</style>
